import { WebPlugin } from '@capacitor/core';
export class SipPhoneControlWeb extends WebPlugin {
    initialize() {
        return Promise.reject('Not implemented on Web platform');
    }
    login(__) {
        return Promise.reject('Not implemented on Web platform');
    }
    logout() {
        return Promise.reject('Not implemented on Web platform');
    }
    acceptCall() {
        return Promise.reject('Not implemented on Web platform');
    }
    call(__) {
        return Promise.reject('Not implemented on Web platform');
    }
    hangUp() {
        return Promise.reject('Not implemented on Web platform');
    }
}
//# sourceMappingURL=web.js.map